// /* eslint-disable no-console */

// import { register } from "register-service-worker";
// import store from "@/store/store";

// if (process.env.NODE_ENV === "production") {
//   register(`${process.env.BASE_URL}service-worker.js`, {
//     ready() {
//       console.log("ready(): App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB");
//     },
//     registered() {
//       console.log("registered(): Service worker has been registered.");
//     },
//     cached() {
//       console.log("cached(): Content has been cached for offline use.");
//     },
//     updatefound() {
//       console.log("updatefound(): New content is downloading.");
//       //TODO: fix bug where this snakbar doesn't go away. This one should timeout, the other updated() one should stick around
//       //store.commit("snackbar", { message: "Update found, new content downloading..."});
//     },
//     updated() {
//       console.log("updated(): New content is available; please refresh.");
//       store.commit("snackbar", { message: "Software updated, please restart application."});
//     },
//     offline() {
//       console.log("offline(): No internet connection found. App is running in offline mode.");
//     },
//     error(error) {
//       console.error("Error during service worker registration:", error);
//     }
//   });
// }

// /* eslint-disable no-console */
import { Workbox } from "workbox-window";

let wb: Workbox | null = null;

if (wb) console.log("wb already created.");

if (!wb && process.env.NODE_ENV === "production") {
  console.log("registering workbox window");
  if ("serviceWorker" in navigator) {
    wb = new Workbox(`${process.env.BASE_URL}service-worker.js`);

    wb.addEventListener("controlling", () => {
      window.location.reload();
    });

    wb.register();
  } else {
    wb = null;
  }
}

export default wb;
